<!-- Registration Form with Steps -->
<section class="form-section" [class.no-background]="!hasBackground">
  <div class="form-card container">
    <h2>Criar conta</h2>
    <p class="subtitle">Junte-se a nós e comece sua jornada</p>

    <div class="steps">
      <div class="step" [class.active]="step === 1">
        <span class="num">1</span>
        <small>Telefone</small>
      </div>
      <div class="step" [class.active]="step === 2">
        <span class="num">2</span>
        <small>Verificação</small>
      </div>
      <div class="step" [class.active]="step === 3">
        <span class="num">3</span>
        <small>Dados pessoais</small>
      </div>
    </div>

    <form [formGroup]="form" autocomplete="off">
      <!-- Step 1: Telefone -->
      <div *ngIf="step === 1">
        <label class="label">Informe seu celular</label>
        <p class="info">
          Digite seu número abaixo para enviarmos seu código SMS:
        </p>
        <mat-form-field appearance="outline" class="form-default">
          <mat-label>Celular</mat-label>
          <input
            matInput
            placeholder="Insira seu numero"
            mask="(00) 00000-0000"
            formControlName="phone"
          />
          <mat-icon matSuffix>phone</mat-icon>
          @if (f['phone'].touched && f['phone'].invalid) {
          <mat-error>Digite um número válido</mat-error>
          }
        </mat-form-field>
        <button
          class="btn submit"
          (click)="sendCode()"
          [disabled]="f['phone'].invalid || loading"
        >
          {{ loading ? "Enviando..." : "Enviar código" }}
        </button>
      </div>

      <!-- Step 2: Código -->
      <div *ngIf="step === 2">
        <label class="label">Confirme o código</label>
        <p class="info">Digite o código enviado para seu celular</p>

        <div class="c-otp" [class.error]="otpError">
          <ngx-otp-input
            formControlName="code"
            [config]="{ length: 6 }"
            (onInputChange)="onOtpChange($event); clearOtpError()"
          ></ngx-otp-input>
        </div>
        <div class="resend-row">
          <span>Ainda não recebeu o código?</span>
          <a
            href="#"
            (click)="$event.preventDefault(); sendCode()"
            [class.disabled]="!canResend"
            [attr.aria-disabled]="!canResend"
            [attr.tabindex]="canResend ? 0 : -1"
          >
            Enviar novamente
          </a>
          <span *ngIf="!canResend" class="resend-timer"
            >({{ formatTimer(resendTimer) }})</span
          >
        </div>
        <button
          class="btn submit"
          (click)="validateCode()"
          [disabled]="f['code'].invalid || loading"
        >
          {{ loading ? "Verificando..." : "Continuar" }}
        </button>
      </div>

      <!-- Step 3: Dados pessoais -->
      <div *ngIf="step === 3">
        <label class="label">Faça seu cadastro</label>
        <p class="info">Preencha os dados para completar seu cadastro</p>
        <mat-form-field appearance="outline" class="form-default">
          <mat-label>Nome completo</mat-label>
          <input
            matInput
            placeholder="Digite seu nome"
            formControlName="name"
          />
          <mat-icon matSuffix>person</mat-icon>
          @if (f['name'].touched && f['name'].invalid) {
          <mat-error>Digite seu nome completo</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-default">
          <mat-label>CPF</mat-label>
          <input
            matInput
            placeholder="Digite seu CPF"
            mask="000.000.000-00"
            formControlName="cpf"
          />
          <mat-icon matSuffix>badge</mat-icon>
          @if (f['cpf'].touched && f['cpf'].invalid) {
          <mat-error>Digite um CPF válido</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-default">
          <mat-label>E-mail</mat-label>
          <input
            matInput
            type="email"
            placeholder="Digite seu e-mail"
            formControlName="email"
          />
          <mat-icon matSuffix>email</mat-icon>
          @if (f['email'].touched && f['email'].invalid) {
          <mat-error>Digite um e-mail válido</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-default">
          <mat-label>Data de nascimento</mat-label>
          <input matInput type="date" formControlName="birthdate" />
          <mat-icon matSuffix>calendar_today</mat-icon>
          @if (f['birthdate'].touched && f['birthdate'].invalid) {
          <mat-error>Digite uma data válida</mat-error>
          }
        </mat-form-field>

        <mat-form-field
          *ngIf="binActive"
          appearance="outline"
          class="form-default"
        >
          <mat-label>BIN</mat-label>
          <input
            matInput
            placeholder="Digite o BIN (6 ou 8 dígitos)"
            formControlName="bin"
            (keypress)="validateNumberInput($event)"
          />
          <mat-icon matSuffix>security</mat-icon>
          @if (f['bin'] && f['bin'].touched && f['bin'].invalid) {
          <mat-error>Digite um BIN válido (6 ou 8 dígitos)</mat-error>
          }
        </mat-form-field>

        <div class="notify-options">
          <div class="accept-row">
            <mat-checkbox
              color="primary"
              formControlName="notifyEmail"
              (change)="onNotifyPreferenceChange()"
            >
              Aceito receber promoções, cupons e outras comunicações do Madero por
              e-mail
            </mat-checkbox>
          </div>
          <div class="accept-row">
            <mat-checkbox
              color="primary"
              formControlName="notifySms"
              (change)="onNotifyPreferenceChange()"
            >
              Aceito receber promoções, cupons e outras comunicações do Madero por
              SMS
            </mat-checkbox>
          </div>
          <div class="accept-row">
            <mat-checkbox
              color="primary"
              formControlName="notifyWpp"
              (change)="onNotifyPreferenceChange()"
            >
              Aceito receber promoções, cupons e outras comunicações do Madero por
              WhatsApp
            </mat-checkbox>
          </div>
          <div class="accept-row">
            <mat-checkbox
              color="primary"
              formControlName="notifyAll"
              (change)="toggleAllNotifications($event.checked)"
            >
              Aceitar todas as opções acima
            </mat-checkbox>
          </div>
        </div>

        <div class="accept-row">
          <mat-checkbox color="primary" formControlName="accept">
            Aceito os termos do programa de fidelidade Madero Cashback
          </mat-checkbox>
          @if (f['accept'].touched && f['accept'].invalid) {
          <mat-error class="checkbox-error"
            >Você precisa aceitar os termos para continuar</mat-error
          >
          }
        </div>
        <button class="btn submit" 
                (click)="submitPersonal()"
                [disabled]="!form.valid || loading">
          {{ loading ? "Enviando..." : "Finalizar" }}
        </button>
      </div>

      <!-- Mensagem de erro global -->
      <div *ngIf="error" class="form-error global-error">
        {{ error }}
      </div>
    </form>

    <!-- Step 4: Sucesso -->
    <div *ngIf="step === 4" class="success-box">
      <mat-icon class="success-icon">check_circle_outline</mat-icon>
      <h3>Tudo certo.</h3>
      <p>Seu cadastro está completo!</p>
    </div>
    <div class="policy-row">
      <a href="#" (click)="$event.preventDefault(); onRedirect('privacy')">
        Políticas de Privacidade
      </a>      |
      <a href="#" (click)="$event.preventDefault(); onRedirect('terms')">
        Termos de uso
      </a>
    </div>
  </div>
</section>
